import { defineComponent as _defineComponent } from 'vue'
import VChart from 'ah-reports/src/components/VChart.vue';
import { PropType, computed } from 'vue';


import { PropOptions } from 'vue';
import { ChartOptions, ChartData } from 'chart.js';

export const doughnutChartProps = {
  options: {
    type: Object as PropType<ChartOptions<'doughnut'>>,
    required: true,
  },
  data: {
    type: Object as PropType<ChartData>,
    required: true,
  },
  mainLabel: {
    type: String,
    default: '',
  },
  secondaryLabel: {
    type: String,
    default: '',
  },
} satisfies Record<string, PropOptions>;

export default /*#__PURE__*/_defineComponent({
  __name: 'DoughnutChart',
  props: doughnutChartProps,
  setup(__props) {

const options = __props;



// Typing Doughnut options as the more generic ChartOptions to make Typescript happy
const doughnutOptions = computed(() => options.options as ChartOptions);

return { __sfc: true,doughnutChartProps, options, doughnutOptions, VChart }
}

})